// Lee cualquier archivo binario (ej. el .cer o .key del certificado de sello
// digital) y lo regresa como base64 puro — sin el prefijo "data:...;base64,"
// que agrega el navegador — porque así es como lo espera el proveedor de
// timbrado (Facturama) en el backend.
export function archivoABase64(archivo: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const lector = new FileReader();
    lector.onerror = () => reject(new Error("No se pudo leer el archivo"));
    lector.onload = () => {
      const resultado = lector.result as string;
      const base64 = resultado.split(",")[1] ?? resultado;
      resolve(base64);
    };
    lector.readAsDataURL(archivo);
  });
}
